import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

export const twMerge = extendTailwindMerge({
    prefix: 'tw-'
});

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function stripDefaultTextColorIfCustomExists(baseClass = '', userClass = '') {
    const hasArbitraryTextColor = /\btw-text-\[#.*?\]/.test(userClass);

    if (!hasArbitraryTextColor) return baseClass;

    // Remove only "base" tw-text-* (not hover/focus or text size)
    return baseClass
        .split(' ')
        .filter(
            cls =>
                // Keep if NOT a base tw-text-* color
                !/^tw-text-[a-zA-Z0-9-]+$/.test(cls)
        )
        .join(' ');
}
